import { _ } from "../polyglot/polyglot.js";
import { keyIcon } from "../elements/icons/index.js";
import { medium } from "../elements/size/index.js";
import { required } from "./forms/validators.js";
import { spacer } from "../elements/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import KeyFigurePreset from "../../models/keyFigure/preset/KeyFigurePreset.js";
import regionWidget from "./regionWidget.js";

/**
 * `keyFigurePresetsManagerWidget` is
 */
function keyFigurePresetsManagerWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);
	let presets = spec.presets || [];

	let isInitialized = presets !== undefined;

	that.onPresetCreated = my.events.createEvent();
	that.onPresetClicked = my.events.createEvent();

	let presetFormModel = {};

	my.createPresetButton = regionWidget({
		content: function (html) {
			html.a(
				{
					klass: [
						"btn",
						"btn-primary",
						"pull-right",
						{ disabled: !isInitialized },
					],
					"data-test": "create-preset",
					click: my.createPresetDialog,
				},
				_("Create preset"),
			);
		},
	});

	my.createPresetDialog = function () {
		my.configure({
			title: _("Create Preset"),
			okLabel: _("Create preset"),
			formSpec: {
				saveAction: createPreset,
				model: presetFormModel,
			},
			formBuilder: (form) => {
				form.input({
					placeHolder: _("Profit Key Figures"),
					label: _("Name"),
					name: "name",
					accessor: () => "",
					mutator: (value) => (presetFormModel.name = value),
					validator: required(),
				});

				form.input({
					label: _("Description"),
					name: "description",
					accessor: () => "",
					mutator: (value) => (presetFormModel.description = value),
					placeHolder: _("All Key Figures related to profits"),
					validator: required(),
				});
			},
		});
	};

	my.presetsList = regionWidget({
		content: (html) => {
			if (!presets.length) {
				return;
			}

			html.div(
				{ klass: "list-stripped" },
				html.ul(presets.map(presetRenderer)),
			);
		},
	});

	that.setPresets = function (newPresets) {
		presets = newPresets;
		isInitialized = true;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.render(my.presetsList);
		html.render(my.createPresetButton);
	};

	function presetRenderer(preset) {
		return function (html) {
			html.li(
				{
					klass: `clearfix${
						preset.isSystemPreset() ? "" : " no-icon"
					}`,
				},
				(html) => {
					if (preset.isSystemPreset()) {
						spacer(
							{ size: medium, right: true, renderOn: html },
							keyIcon,
						);
					}
					if (preset.isVisible) {
						html.render(preset.getName());
					} else {
						html.tag("del").render(preset.getName());
					}

					html.div(
						{ klass: "pull-right" },
						html.a(
							{
								"data-test": "edit",
								click: () =>
									that.onPresetClicked.trigger(preset),
							},
							_("Edit"),
						),
					);
				},
			);
		};
	}

	function createPreset() {
		const newPreset = new KeyFigurePreset({
			name: presetFormModel.name,
			description: presetFormModel.description,
			keyFigures: [],
			isSystemPreset: false,
			isVisible: true,
		});
		presetFormModel = {};
		that.onPresetCreated.trigger(newPreset);
	}

	return that;
}

export default keyFigurePresetsManagerWidget;
